import { API, Auth } from 'aws-amplify';
import { USER_INFO_LOADED } from '../constants/actionTypes';
import { setAggregationCurrency } from './currencies';
import { storage } from '../storage';

export function initUserInfo() {
  return async dispatch => {
    try {
      const init = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      };
      const userInfo = await API.get('UserInfoGateway', '/user_info', init);
      if (userInfo.aggregationCurrency) {
        storage.setItem('aggregationCurrency', userInfo.aggregationCurrency);
        dispatch(setAggregationCurrency(userInfo.aggregationCurrency));
      }
      dispatch({ type: USER_INFO_LOADED, payload: userInfo });
    } catch (err) {
      console.warn('Could not load user info, defaulting to free tier:', err);
      dispatch({ type: USER_INFO_LOADED, payload: { tier: 'free' } });
    }
  };
}
